"use strict";

function e(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function t(e) {
  return (t = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function i(e, t) {
  return (i = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function n() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function a(e, t, s) {
  return (a = n() ? Reflect.construct : function (e, t, n) {
    var a = [null];
    a.push.apply(a, t);
    var s = new (Function.bind.apply(e, a))();
    return n && i(s, n.prototype), s;
  }).apply(null, arguments);
}
function s(e) {
  var n = "function" == typeof Map ? new Map() : void 0;
  return (s = function s(e) {
    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== n) {
      if (n.has(e)) return n.get(e);
      n.set(e, s);
    }
    function s() {
      return a(e, arguments, t(this).constructor);
    }
    return s.prototype = Object.create(e.prototype, {
      constructor: {
        value: s,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), i(s, e);
  })(e);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var r = ["Alt", "Control", "Enter", "Meta", "Shift", "Tab"];
function l(e, t) {
  return Array.from({
    length: t
  }, function (t, i) {
    return i + e;
  });
}
function o(e) {
  return Math.max(0, e - 1);
}
function u(e, t) {
  return 0 === t ? 0 : Math.min(e + 1, t - 1);
}
var c = function (t) {
  var n, a;
  function s() {
    var e;
    return (e = t.apply(this, arguments) || this).cursor = 0, e.actions = [], e.effects = [], e.fallback = null, e.inputs = [], e.length = 5, e.validate = /^[a-zA-Z0-9]$/, e.format = function (e) {
      return e;
    }, e;
  }
  a = t, (n = s).prototype = Object.create(a.prototype), n.prototype.constructor = n, i(n, a);
  var c,
    d,
    h,
    p = s.prototype;
  return p.isKeyAllowed = function (e) {
    return !!e && !(e.length > 1) && ("string" == typeof this.validate ? this.validate.split("").includes(e) : this.validate instanceof Array ? this.validate.includes(e) : this.validate instanceof RegExp ? this.validate.test(e) : this.validate(e));
  }, p.log = function (e, t, i) {
    this.debug && console.debug("[PIN Field] (" + e + ") " + t + (i ? ": " + i : ""));
  }, p.attributeChangedCallback = function (e, t, i) {
    var n = this;
    if (t !== i) switch (e) {
      case "debug":
        this.debug = null !== i;
        break;
      case "disabled":
        this.inputs.forEach(function (e) {
          return e.disabled = n.disabled;
        });
    }
  }, p.connectedCallback = function () {
    var e = this;
    if (this.hasAttribute("length") && (this.length = Number(this.getAttribute("length")) || 5, this.length < 1)) throw new RangeError("The PIN Field length should be greater than 0 (got " + this.length + ")");
    var t = this.getAttribute("validate");
    "string" == typeof t && (this.validate = t);
    var i = document.createElement("input");
    i.autocapitalize = "off", i.autocomplete = "off", i.inputMode = "text";
    for (var n = [], a = function a(t) {
        var a = e.attributes[t];
        ["id", "autofocus", "debug"].includes(a.name) || (i.setAttribute(a.name, a.value), n.push(function () {
          return a && e.removeAttribute(a.name);
        }));
      }, s = 0; s < this.attributes.length; s++) a(s);
    this.append.apply(this, l(0, this.length).map(function (t) {
      var n = i.cloneNode(!0);
      return 0 === t && e.hasAttribute("autofocus") && (n.setAttribute("autofocus", ""), e.removeAttribute("autofocus")), e.inputs.push(n), n;
    }));
    var r = document.createElement("slot"),
      o = document.createElement("style");
    o.innerText = ":host{display:flex;}", this.attachShadow({
      mode: "open"
    }).append(o, r), n.forEach(function (e) {
      return e();
    }), this.inputs.forEach(function (t, i) {
      t.addEventListener("keydown", e.handleKeyDown(i)), t.addEventListener("keyup", e.handleKeyUp(i)), t.addEventListener("paste", e.handlePaste(i));
    });
  }, p.disconnectedCallback = function () {
    var e = this;
    this.inputs.forEach(function (t, i) {
      t.removeEventListener("keydown", e.handleKeyDown(i)), t.removeEventListener("keyup", e.handleKeyUp(i)), t.removeEventListener("paste", e.handlePaste(i));
    });
  }, p.applySetValAt = function (e, t) {
    if (t.split("").slice(0, this.length).every(this.isKeyAllowed.bind(this))) {
      var i,
        n = Math.min(t.length, this.length - e),
        a = u(n + e - 1, this.length);
      (i = this.effects).push.apply(i, [{
        type: "handle-code-change"
      }, {
        type: "focus-input",
        idx: a
      }].concat(l(0, n).flatMap(function (i) {
        return [{
          type: "set-input-val",
          idx: e + i,
          val: t[i]
        }, {
          type: "resolve-key",
          idx: e + i,
          key: t[i]
        }];
      })));
    } else this.effects.push({
      type: "handle-code-change"
    }, {
      type: "reject-key",
      idx: e,
      key: t
    }, {
      type: "set-input-val",
      idx: e,
      val: ""
    });
  }, p.executeAll = function () {
    for (; this.actions.length > 0;) {
      var e = this.actions.pop();
      switch (e.type) {
        case "handle-key-down":
          switch (this.log("action", "handle-key-down", "key=" + e.key), e.key) {
            case "Unidentified":
              this.fallback = {
                idx: e.idx,
                val: e.val
              };
              break;
            case "Dead":
              this.effects = [{
                type: "handle-code-change"
              }, {
                type: "reject-key",
                idx: e.idx,
                key: e.key
              }, {
                type: "set-input-val",
                idx: e.idx,
                val: ""
              }];
              break;
            case "ArrowLeft":
              this.cursor = o(e.idx), this.effects = [{
                type: "focus-input",
                idx: this.cursor
              }];
              break;
            case "ArrowRight":
              this.cursor = u(e.idx, this.length), this.effects = [{
                type: "focus-input",
                idx: this.cursor
              }];
              break;
            case "Delete":
            case "Backspace":
              this.effects = [{
                type: "handle-code-change"
              }, {
                type: "handle-delete",
                idx: e.idx
              }];
              break;
            default:
              this.isKeyAllowed(e.key) ? (this.cursor = u(e.idx, this.length), this.effects = [{
                type: "handle-code-change"
              }, {
                type: "focus-input",
                idx: this.cursor
              }, {
                type: "resolve-key",
                idx: e.idx,
                key: e.key
              }, {
                type: "set-input-val",
                idx: e.idx,
                val: e.key
              }]) : this.effects = [{
                type: "reject-key",
                idx: e.idx,
                key: e.key
              }];
          }
          break;
        case "handle-key-up":
          if (!this.fallback) {
            this.log("action", "handle-key-up", "ignored");
            break;
          }
          this.log("action", "handle-key-up");
          var t = this.fallback,
            i = t.idx,
            n = t.val,
            a = e.val;
          "" === n && "" === a ? this.effects.push({
            type: "handle-delete",
            idx: i
          }, {
            type: "handle-code-change"
          }) : "" !== n && "" !== a ? (a = n === a[0] ? a.substring(1) : a.substring(0, a.length - 1), this.applySetValAt(i, a)) : "" !== a && this.applySetValAt(i, a), this.fallback = null;
          break;
        case "handle-paste":
          this.applySetValAt(e.idx, e.val);
      }
    }
  }, p.applyAll = function () {
    for (; this.effects.length > 0;) {
      var e = this.effects.pop();
      switch (e.type) {
        case "focus-input":
          this.log("effect", "focus-input", "idx=" + e.idx), this.inputs[e.idx].focus();
          break;
        case "set-input-val":
          this.log("effect", "set-input-val", "idx=" + e.idx + ",val=" + e.val);
          var t = this.format(e.val);
          this.inputs[e.idx].value = t;
          break;
        case "resolve-key":
          this.log("effect", "resolve-key", "idx=" + e.idx + ",key=" + e.key), this.inputs[e.idx].setCustomValidity(""), this.dispatchEvent(new CustomEvent("resolve", {
            detail: {
              key: e.key
            }
          }));
          break;
        case "reject-key":
          this.log("effect", "reject-key", "idx=" + e.idx + ",key=" + e.key), this.inputs[e.idx].setCustomValidity("Invalid key"), this.dispatchEvent(new CustomEvent("reject", {
            detail: {
              key: e.key
            }
          }));
          break;
        case "handle-delete":
          this.log("effect", "handle-delete", "idx=" + e.idx);
          var i = this.inputs[e.idx].value;
          if (this.inputs[e.idx].setCustomValidity(""), this.inputs[e.idx].value = "", !i) {
            var n = o(e.idx);
            this.inputs[n].focus(), this.inputs[n].setCustomValidity(""), this.inputs[n].value = "";
          }
          break;
        case "handle-code-change":
          var a = (document.documentElement.getAttribute("dir") || "ltr").toLowerCase(),
            s = this.inputs.map(function (e) {
              return e.value.trim();
            }),
            r = ("rtl" === a ? s.reverse() : s).join("");
          this.log("effect", "handle-code-change", "val={" + r + "}"), this.dispatchEvent(new CustomEvent("change", {
            detail: {
              value: r
            }
          })), r.length === this.length ? (this.setAttribute("completed", ""), this.dispatchEvent(new CustomEvent("complete", {
            detail: {
              value: r
            }
          }))) : this.removeAttribute("completed");
      }
    }
  }, p.render = function () {
    this.executeAll(), this.applyAll();
  }, p.handleKeyDown = function (e) {
    var t = this;
    return function (i) {
      if (r.includes(i.key) || i.ctrlKey || i.altKey || i.metaKey) t.log("handleKeyDown", "ignored", "idx=" + e + ",key=" + i.key);else if (i.target instanceof HTMLInputElement) {
        i.preventDefault();
        var n = i.target.value;
        t.log("handleKeyDown", "triggered", "idx=" + e + ",key=" + i.key + ",val=" + n), t.actions.push({
          type: "handle-key-down",
          idx: e,
          key: i.key,
          val: n
        }), t.render();
      }
    };
  }, p.handleKeyUp = function (e) {
    var t = this;
    return function (i) {
      if (i.target instanceof HTMLInputElement) {
        var n = i.target.value;
        t.log("handleKeyUp", "triggered", "idx=" + e + ",val=" + n), t.actions.push({
          type: "handle-key-up",
          idx: e,
          val: n
        }), t.render();
      }
    };
  }, p.handlePaste = function (e) {
    var t = this;
    return function (i) {
      i.preventDefault();
      var n = i.clipboardData ? i.clipboardData.getData("Text") : "";
      t.log("handlePaste", "triggered", "idx=" + e + ",val=" + n), t.actions.push({
        type: "handle-paste",
        idx: e,
        val: n
      }), t.render();
    };
  }, c = s, h = [{
    key: "observedAttributes",
    get: function get() {
      return ["debug", "disabled"];
    }
  }], (d = [{
    key: "debug",
    get: function get() {
      return this.hasAttribute("debug");
    },
    set: function set(e) {
      e ? this.setAttribute("debug", "") : this.removeAttribute("debug");
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.hasAttribute("disabled");
    },
    set: function set(e) {
      e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
    }
  }]) && e(c.prototype, d), h && e(c, h), s;
}(s(HTMLElement));
customElements.define("swd-pin-field", c), exports.PinField = c, exports.default = c;